import React, { FC } from 'react';

import { isEmpty } from 'lodash-es';
import { useIntl } from 'react-intl';

import { useEnableCartV2Experiment } from 'experiments/use-enable-cart-v2-experiment';
import { useGetAndLogUserErrorMessage } from 'hooks/log-user-error-message';
import { selectors, useAppSelector } from 'state/global-state';

import { StyledIncentiveEvaluationMessage, StyledIncentiveEvaluationMessages } from '../styled';

interface ICartErrorMessagesProps {
  isOfferNotAvailable: boolean;
  isCartTotalNegative: boolean;
}

export const CartErrorMessages: FC<React.PropsWithChildren<ICartErrorMessagesProps>> = ({
  isOfferNotAvailable,
  isCartTotalNegative,
}) => {
  const enableCartV2 = useEnableCartV2Experiment();

  const { formatMessage } = useIntl();
  const offersFeedbackMap = useAppSelector(selectors.loyalty.selectOfferFeedbackMap);

  const showOffersFeedback = !isCartTotalNegative && !isEmpty(offersFeedbackMap);

  const getOfferNotAvailableInRestaurantPosMessage = useGetAndLogUserErrorMessage({
    message: formatMessage({ id: 'offerNotAvailableInRestaurantPos' }),
  });

  const getNegativeCartErrorMessage = useGetAndLogUserErrorMessage({
    message: formatMessage({ id: 'negativeCartError' }),
  });

  if (enableCartV2) {
    if (isOfferNotAvailable) {
      getOfferNotAvailableInRestaurantPosMessage();
    } else if (isCartTotalNegative) {
      getNegativeCartErrorMessage();
    }

    return null;
  }

  return (
    <>
      {isOfferNotAvailable && (
        <StyledIncentiveEvaluationMessage
          // @ts-expect-error TS(2322) FIXME: Type '{ testID: string; message: string; }' is not... Remove this comment to see the full error message
          testID="offerNotAvailableInRestaurantPosErrorMsg"
          message={getOfferNotAvailableInRestaurantPosMessage()}
        />
      )}
      {showOffersFeedback &&
        Object.keys(offersFeedbackMap).map(key => (
          <StyledIncentiveEvaluationMessages
            key={key}
            incentiveEvaluationResults={offersFeedbackMap[key]}
          />
        ))}
      {isCartTotalNegative && (
        <StyledIncentiveEvaluationMessage message={getNegativeCartErrorMessage()} />
      )}
    </>
  );
};
